import { StaticImageData } from 'next/image'
import GenerateImageMob1x from './generate-desk@1x.webp'
import GenerateImageMob2x from './generate-desk@2x.webp'
import GenerateImageDesk1x from './generate-desk@1x.webp'
import GenerateImageDesk2x from './generate-desk@2x.webp'
import ConnectImageMob1x from './connect-mob@1x.webp'
import ConnectImageMob2x from './connect-mob@2x.webp'
import ConnectImageDesk1x from './connect-desk@1x.webp'
import ConnectImageDesk2x from './connect-desk@2x.webp'
import ImplementImageMob1x from './implement-mob@1x.png'
import ImplementImageMob2x from './implement-mob@2x.png'
import ImplementImageDesk1x from './implement-desk@1x.png'
import ImplementImageDesk2x from './implement-desk@2x.png'

export type AIContentDataType = {
  tag: string
  title: string
  visual: AIContentVisualType | null
  description: string[]
}

type AIContentVisualType = {
  imageMob1x: StaticImageData
  imageMob2x: StaticImageData
  imageDesk1x: StaticImageData
  imageDesk2x: StaticImageData
  hasMobile?: boolean
}

export const aiContentData: AIContentDataType[] = [
  {
    tag: '01',
    title: 'Generate and Test Universal Connectors',
    visual: {
      imageMob1x: GenerateImageMob1x,
      imageMob2x: GenerateImageMob2x,
      imageDesk1x: GenerateImageDesk1x,
      imageDesk2x: GenerateImageDesk2x,
    },
    description: [
      'We feed API documentation and specifications into LLMs and ask it thousands of very specific questions. We validate the results and combine them into a Universal Connector that contains the all the details about integrating with a given app in a consistent format that can be used to build integrations automatically.',
      'We also preserve the raw information: documentation pages and API specs - to provide additional unstructured context when necessary.',
    ],
  },
  {
    tag: '02',
    title: 'Connect Your Code to Universal Integration Blocks',
    visual: {
      imageMob1x: ConnectImageMob1x,
      imageMob2x: ConnectImageMob2x,
      imageDesk1x: ConnectImageDesk1x,
      imageDesk2x: ConnectImageDesk2x,
    },
    description: [
      'To increase the precision of AI, our platform maps your integration use case to well-defined building blocks that represent every type of integration primitive: actions, flows, events, field mappings, etc.',
      'Each building block is then connected to integration points inside your application.',
      'This provides you with a consistent way to interact with external apps while giving AI enough details to build high-quality app-specific and customer-specific implementations.',
    ],
  },
  {
    tag: '03',
    title: 'Generate App-specific Implementations of Universal Blocks',
    visual: {
      imageMob1x: ImplementImageMob1x,
      imageMob2x: ImplementImageMob2x,
      imageDesk1x: ImplementImageDesk1x,
      imageDesk2x: ImplementImageDesk2x,
      hasMobile: true,
    },
    description: [
      'Then we map each building block in your use case to each application using information from the connector - both structured and unstructured. If connector has enough information to implement a building block according to your specification, it is generated automatically.',
      'In some cases, connectors do not have enough information or cannot make a decision automatically because it is too ambiguous. Our platform will let you know when it happens and let you (or our solutions team) fill the gaps.',
    ],
  },
  {
    tag: 'Result',
    title: 'Hundreds of high-quality deep native integrations',
    visual: null,
    description: [
      'The process above is the only practical way to integrate with hundreds or thousands of apps for any non-trivial integration use case.',
      'The more integrations are built with us, the smarter our AI becomes when building the next one.',
    ],
  },
]
